<div class="row">
  <div class="icon">
    <ion-icon [name]="icon()"></ion-icon>
  </div>
  <div class="details">
    <div class="top">{{ addressMainText() }}</div>
    <div class="bottom">{{ addressSecondaryText() }}</div>
  </div>
  @if (canRemove()) {
    <div class="remove-icon" (click)="onRemove($event)">
      <ion-icon name="close"></ion-icon>
    </div>
  }
</div>